export enum AccessLevel {
    Full = "full",
    None = "none",
    Page = "page",
    ReadOnly = "readOnly",
}
